import React, { useRef, useEffect } from "react";
import SourceCard from "../components/sections/SourceCard";
import UseCaseCard from "../components/sections/UseCaseCard";
import Image from "../components/elements/Image";
import { Link } from "react-router-dom";
import ScrollReveal from "../utils/ScrollReveal";
import HelmetWrapper from "../components/sections/HelmetWrapper";
import { revOpsMetaData } from "../seo/metaDeta";
// can edit use cases from this array.
let useCases = [
  {
    tag: "centralize",
    heading: "Sync up data from sales, marketing, and customer success",
    subHeading:
      "With 140+ no-code connectors, you can automatically extract and incorporate data from siloed databases and Saas sources, so you don't have to waste time manually exporting data.",
    img: require("../assets/images/revenue-operations-feature-1.svg"),
  },
  {
    tag: "value",
    heading: "Understand and optimize your entire revenue funnel",
    subHeading:
      "When all of your data is stored in a data warehouse, complex analysis becomes simple. Identifying opportunities simply tracking the conversion rates along the entire revenue funnel.",
    img: require("../assets/images/revenue-operations-feature-2.svg"),
  },
  {
    tag: "insights",
    heading: "Equip revenue teams with key data points",
    subHeading:
      "Align all teams around a single source of truth. Then empower them to sell more effectively, invest in the right marketing channels, and maximize revenue from customers.",
    img: require("../assets/images/revenue-operations-feature-3.svg"),
  },
];

let Connectors = [
  {
    name: "Salesforce",
    img: require("../assets/images/connectors/salesforce.png"),
    isAlpha: false,
    link: "",
    category: "",
  },
  {
    name: "Hubspot",
    img: require("../assets/images/connectors/hubspot.png"),
    isAlpha: false,
  },
  {
    name: "Quickbooks",
    img: require("../assets/images/connectors/quickbooks.png"),
    isAlpha: false,
  },
  {
    name: "Google Ads",
    img: require("../assets/images/connectors/google_ads.png"),
    isAlpha: false,
  },
];
const RevenueOperations = () => {
  const childRef = useRef();
  useEffect(() => {
    childRef.current.init();
  }, []);
  return (
    <>
      <HelmetWrapper {...revOpsMetaData} />
      <ScrollReveal
        ref={childRef}
        children={() => (
          <div className="container use">
            <div className="use__container">
              <div className="use__text-container">
                <div className="use__text-tag reveal-from-left">
                  Revenue Operations Use Cases
                </div>
                <div className="use__text-heading reveal-from-left">
                  Devise a unified revenue-generating strategy
                </div>
                <div className="use__text-sub reveal-from-bottom">
                  Fuel teams with game-changing insights
                </div>
              </div>
              <img
                className="use__background reveal-from-right"
                src={require("../assets/images/revenue-operations-main.svg")}
                alt="case"
              />
            </div>
            {/* <div className="divider" /> */}
            {/* <div
        className="use__testimonial-box reveal-from-bottom"
        data-reveal-delay="200"
      >
        <img src={require("../assets/images/docker.svg")} alt="company_logo" />
        <div className="use__testimonial-text">
          "Most marketing people don't know how to build a data stack. Because
          of the CSM and the analyst support we’re getting from Mozart Data, it
          gives me more confidence in what we’re doing. It’s great to have a
          professional available to help answer the deeper questions."
        </div>
        <div className="use__testimonial-author">
          <img
            src={require("../assets/images/author.png")}
            alt="author"
            className="author-img"
          />
          <div className="author-name">
            Kristin Watson{" "}
            <span className="author-position">/ CEO, Docker</span>
          </div>
        </div>
      </div> */}
            <div className="divider" />
            <div className="use__cases-box">
              {useCases.map((item, index) => {
                return <UseCaseCard data={item} key={index} index={index} />;
              })}
            </div>
            <div className="datazip__case">
              <div className="heading"> Use Cases</div>
              {/* <div className="subHeading">
          Please let us know, we will get back to you about how quickly we can
          make it available
        </div> */}
              <div className="box">
                <div className="tiles-item reveal-from-bottom">
                  {/* start  */}
                  <div className="tiles-item-inner">
                    <div className="features-tiles-item-header ta-c">
                      <div className="features-tiles-item-image mb-16 ">
                        <Image
                          src={require("./../assets/images/revenue-operations-feature-tile-icon-01.svg")}
                          alt="Features tile icon 01"
                          width={64}
                          height={64}
                        />
                      </div>
                    </div>
                    <div className="features-tiles-item-content ta-c">
                      {/* <h4 className="mt-0 mb-8">No-Code</h4> */}
                      <p className="m-0 text-sm">
                        Monitor KPIs for marketing, sales, and customer
                        satisfaction
                      </p>
                    </div>
                    <button className="button__main">
                      Read More{" "}
                      <img
                        src={require("./../assets/images/long-arrow-right.svg")}
                        alt="arrow right"
                      />
                    </button>
                  </div>
                </div>
                {/* end */}
                {/* start  */}
                <div className="tiles-item reveal-from-bottom">
                  <div className="tiles-item-inner">
                    <div className="features-tiles-item-header ta-c">
                      <div className="features-tiles-item-image mb-16 ">
                        <Image
                          src={require("./../assets/images/revenue-operations-feature-tile-icon-02.svg")}
                          alt="Features tile icon 02"
                          width={64}
                          height={64}
                        />
                      </div>
                    </div>
                    <div className="features-tiles-item-content ta-c">
                      {/* <h4 className="mt-0 mb-8">No-Code</h4> */}
                      <p className="m-0 text-sm">
                        Determine the most profitable opportunities
                      </p>
                    </div>
                    <button className="button__main">
                      Read More{" "}
                      <img
                        src={require("./../assets/images/long-arrow-right.svg")}
                        alt="arrow right"
                      />
                    </button>
                  </div>
                </div>
                <div className="tiles-item reveal-from-bottom">
                  {/* end */}
                  {/* start  */}
                  <div className="tiles-item-inner">
                    <div className="features-tiles-item-header ta-c">
                      <div className="features-tiles-item-image mb-16 ">
                        <Image
                          src={require("./../assets/images/revenue-operations-feature-tile-icon-03.svg")}
                          alt="Features tile icon 03"
                          width={64}
                          height={64}
                        />
                      </div>
                    </div>
                    <div className="features-tiles-item-content ta-c">
                      {/* <h4 className="mt-0 mb-8">No-Code</h4> */}
                      <p className="m-0 text-sm">
                        Plan, anticipate, and budget in a precise manner
                      </p>
                    </div>
                    <button className="button__main">
                      Read More{" "}
                      <img
                        src={require("./../assets/images/long-arrow-right.svg")}
                        alt="arrow right"
                      />
                    </button>
                  </div>
                  {/* end */}
                </div>
              </div>
            </div>
            <div className="integration__box">
              <div className="integration__box-heading">
                Connect your data in minutes
              </div>
              <div className="integration__box-connector">
                {Connectors.map((item, index) => {
                  return <SourceCard source={item} key={index} />;
                })}
              </div>
              <Link to={"/onestack-data/connectors"}>
                <button className="integration__box-button">
                  See all integrations
                </button>
              </Link>
            </div>
            <div className="divider" />
            <div className="use__freeTrial">
              <div className="freeTrial__textbox">
                <div className="freeTrial__textbox-1">
                  All teams can benefit from centralized and reliable data
                </div>
                <div className="freeTrial__textbox-2">
                  Start your free trial today
                </div>
                <div className="freeTrial__elipse"></div>
              </div>
              <div className="freeTrial__cta">
                <a
                  href="https://calendly.com/d/dx2-qrw-g8j/hello-datazip"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="freeTrial__cta-common freeTrial__cta-1">
                    Get Started
                  </button>
                </a>
                {/* <Link to={"/onestack-data/login"}>
                  <button className="button__main button__tertiary">
                    Access Sandbox
                  </button>
                </Link> */}
              </div>
            </div>
          </div>
        )}
      />
    </>
  );
};

export default RevenueOperations;
